import { action } from "mobx";
import { getBrandPageData, getProductsData } from "./service";
import { OLD_MASTER_TEMPLATES } from "../../constants";

class BrandActions {
  @action
  enablePreviewMode() {
    this.previewMode = true;
  }
  @action
  setTemplateValues(id, templateType, legalBrandNames) {
    this.brandId = id;
    this.templateType = templateType;
    this.legalBrandNames = legalBrandNames;
  }

  @action
  setUrlPrefix(data) {
    let prefix;
    if (
      OLD_MASTER_TEMPLATES &&
      OLD_MASTER_TEMPLATES.length &&
      OLD_MASTER_TEMPLATES.includes(this.templateType)
    ) {
      [{ value: prefix }] =
        data &&
        data
          .filter(
            section =>
              section &&
              section.children &&
              section.children.find(item => item.key === "url_prefix"),
          )
          .map(
            item =>
              item.children &&
              item.children.find(
                filteredSection => filteredSection.key === "url_prefix",
              ),
          );
      this.urlPrefix = prefix;
    } else {
      prefix = data && data.find(item => item.urlPrefix);
      this.urlPrefix = prefix && prefix.urlPrefix;
    }
  }
  @action
  getBrandPageData() {
    return new Promise((resolve, reject) => {
      getBrandPageData(this.apiEndPoint)
        .then(res => {
          this.data = res.data;
          this.setUrlPrefix(res.data);
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  @action
  getCarouselData(type, subtype, body) {
    this.tempExtension = `${type}/${subtype}`;
    const basePath = type === "listing" ? "basePathV2" : "basePathV1";
    return new Promise((resolve, reject) => {
      getProductsData(this.tempExtension, body, basePath)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  @action
  appendPrefixToSrc(src) {
    return `${this.urlPrefix}${src}`;
  }
}

export default BrandActions;



// WEBPACK FOOTER //
// ./src/stores/BrandStore/actions.js